import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';

import { withFirebase } from './config/firebase.js';
import { AuthContext } from './config/auth.js';

// import Admin from './pages/admin/admin.jsx';
import AdminNew from './pages/admin/admin_new.jsx';
import Login from './pages/login/login.jsx';
import Pdf from './pages/pdf/pdf.jsx';

class App extends Component {
    constructor(props) {
        super(props);

        this.state = {
            user: 'authenticating'
        };
    }

    componentDidMount() {
        const { auth } = this.props.firebase;

        this.authListener = auth.onAuthStateChanged(user => {
            if(user) {
                this.setState({ user: user });
            }
            else {
                this.setState({ user: null });
            }
        });
    }

    componentWillUnmount() {
        this.authListener && this.authListener();
    }

    render() {
        const { user } = this.state;

        if (user === 'authenticating') return null;

        return (
            <AuthContext.Provider value={user}>
                <Router>
                    <Switch>
                        <Route exact path='/' component={AdminNew} />
                        <Route path='/login' component={Login} />
                        <Route path='/pdf/:url' component={Pdf} />
                    </Switch>
                </Router>
            </AuthContext.Provider>
        );
    }
}

export default withFirebase(App);